import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { z } from 'zod';

import { ImageRenderingPage } from '@/pages/image-rendering';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/image-rendering')({
  component: ImageRenderingPage,
  validateSearch: zodSearchValidator(
    z.object({
      imageId: z.string().optional(),
      estateId: z.string().optional(),
    })
  ),
});
